export default __webpack_public_path__ + "static/media/ita_flag.52d91adf.svg";